<template>
  <form
    @submit.prevent="formValidate"
    class="form form-register"
    novalidate
    autocomplete="off"
  >
    <transition name="fade">
      <div
        v-if="errorMessage"
        class="form-row"
      >
        <div class="form-error q-py-sm text-negative">
          {{ errorMessage }}
        </div>
      </div>
    </transition>

    <q-input
      v-model="form.email"
      v-validate="getVValidate('required|email|uniqueness:email')"
      :error="errors.has('email')"
      :loading="fields.email && fields.email.pending"
      filled
      stack-label
      no-error-icon
      color="black"
      name="email"
      label="Email"
      type="email"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in emailErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <q-input
      v-model.trim="form.username"
      v-validate.continues="getVValidate('required|uniqueness:username')"
      :error="errors.has('username')"
      :loading="fields.username && fields.username.pending"
      filled
      stack-label
      no-error-icon
      color="black"
      name="username"
      label="Username"
      type="text"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in usernameErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <q-input
      ref="password"
      v-model="form.password"
      v-validate="getVValidate('required')"
      :error="errors.has('password')"
      filled
      stack-label
      no-error-icon
      color="black"
      name="password"
      label="Password"
      type="password"
      autocomplete="new-password"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in passwordErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>
    <q-input
      v-model="form.confirmPassword"
      v-validate="getVValidate('required|confirmed:password')"
      :error="errors.has('confirmPassword')"
      filled
      stack-label
      no-error-icon
      color="black"
      name="confirmPassword"
      label="Confirm Password"
      type="password"
      autocomplete="new-password"
      hide-bottom-space
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in confirmPasswordErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
    </q-input>

    <q-field
      :error="errors.has('acceptTerms')"
      borderless
      hide-bottom-space
      no-error-icon
    >
      <template v-slot:error>
        <ul class="list-errors">
          <li
            v-for="(error, errorKey) in acceptTermsErrors"
            :key="errorKey"
            v-html="error"
          />
        </ul>
      </template>
      <template v-slot:control>
        <q-checkbox
          v-model="acceptTerms"
          v-validate="getVValidate('required:true')"
          name="acceptTerms"
          dense
        >
          <template v-slot>
            {{ $t('I accept') }}
            <a
              @click.stop="showTerms"
              href="javascript:;"
            ><strong>{{ $t('Terms & Conditions') }}</strong></a>
          </template>
        </q-checkbox>
      </template>
    </q-field>

    <div class="form-actions">
      <div class="form-row">
        <q-btn
          :label="$t('buttons.register')"
          :loading="isProcessing"
          rounded
          color="primary"
          text-color="white"
          class="full-width"
          type="submit"
        />
      </div>
      <div class="form-row">
        <router-link :to="{ name: 'login' }">
          {{ $t('Login') }}
        </router-link>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import TermsAndConditions from '@/components/common/TermsAndConditions';
import FormBase from './FormBase';

@Component({
  name: 'form-register',
  extends: FormBase,
})
export default class FormRegister extends Vue {
  formScope = 'register';
  form = {
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
  };
  acceptTerms = false;

  showTerms() {
    this.$q.dialog({
      root: this.$root,
      component: TermsAndConditions,
    });
  }

  get acceptTermsErrors() {
    return this.getErrorMessages('acceptTerms', 'Accept Terms');
  }
  get usernameErrors() {
    return this.getErrorMessages('username', 'Username');
  }
  get emailErrors() {
    return this.getErrorMessages('email', 'Email');
  }
  get passwordErrors() {
    return this.getErrorMessages('password', 'Password');
  }
  get confirmPasswordErrors() {
    return this.getErrorMessages('confirmPassword', 'Confirm Password');
  }
}
</script>
<style lang="scss">
.list-errors {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
